import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Typography, Box, Modal,
} from '@material-ui/core';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useStripeSubscription } from '../hooks/useStripeSubscription';
// import styles from './SubscribeModal.module.css';
import {
  makeStyles
} from '@material-ui/core';
import StripeCheckoutForm from './StripeCheckoutForm';

const useStyles = makeStyles((theme) => ({
  paypalBtnBox: {
    position: 'relative',
    display: 'block',
  }
}));

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '640px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};

/**
 * StripeSubscribeModal
 *
 * Props:
 *   isOpen       boolean
 *   onClose      () => void
 *   onSuccess    ({ subscriptionId }) => void
 *   plan         { priceId, name, amount, interval }
 *   user         { email, name }
 */

const StripeSubscribeModal = (props) => {
  const { open, setOpen, item, setItem, updateTimestamp, setUpdateTimestamp, amount = 10, itemType = "device_credit", callback, user_type, user_id, user } = props;
  const { step, error, stripePublishableKey, clientSecret, initSetup, confirmAndSubscribe, subscriptionId, reset } = useStripeSubscription();
  const plan = { priceId: 1, name: "testPlan", amount: 1200, interval: 'month' }; // interval: 'month'/'year'

  //  const user = useSelector((state) => state.session.user);

  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    if (stripePublishableKey) {
      setStripePromise(loadStripe(stripePublishableKey));
    }
  }, [stripePublishableKey])

  const handleModalClose = () => {
    setOpen(false)
  }

  const styles = useStyles();

  const didInit = useRef(false);

  // Kick off the SetupIntent as soon as the modal opens
  useEffect(() => {
    if (!open || didInit.current) return;
    didInit.current = true;
    initSetup({ email: user.email, name: user.name });
  }, [open, initSetup, user]);

  // Clean up on close
  const handleClose = () => {
    didInit.current = false;
    reset();
    onClose();
  };

  const handleSuccess = (data) => {
    onSuccess?.({ subscriptionId: data.subscriptionId });
  };

  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          {/* <Typography id="paypalPaymentFormTitle" className='mt-3'>
            Pay with Paypal
          </Typography> */}

          <div className='text-center' style={{ marginTop: '1rem' }}>
            <div className={styles.overlay} onClick={handleClose} role="dialog" aria-modal="true">
              <div className={styles.modal} onClick={e => e.stopPropagation()}>

                {/* Body */}
                <div className={styles.body}>
                  {step === 'success' ? (
                    <>
                      <div>Success</div>
                      {/* <SuccessView plan={plan} subscriptionId={subscriptionId} onClose={handleClose} /> */}
                    </>

                  ) : (!clientSecret || !stripePromise) ? (
                    <LoadingState />
                  ) : (
                    <Elements
                      stripe={stripePromise}
                      options={{
                        clientSecret,
                        appearance: {
                          theme: 'stripe',
                          variables: {
                            colorPrimary: '#0F6E56',
                            colorBackground: '#ffffff',
                            colorText: '#1a1a1a',
                            colorDanger: '#df1b41',
                            fontFamily: 'system-ui, sans-serif',
                            borderRadius: '8px',
                            spacingUnit: '4px',
                          },
                        },
                      }}
                    >
                      <StripeCheckoutForm
                        plan={plan}
                        step={step}
                        error={error}
                        onConfirm={(stripe, elements) =>
                          confirmAndSubscribe({ stripe, elements, priceId: plan.priceId })
                            .then(handleSuccess)
                            .catch(() => { }) // error already in state
                        }
                      />
                    </Elements>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

function LoadingState() {
  return (
    <div style={{ padding: '2rem 0', textAlign: 'center', color: '#888', fontSize: 14 }}>
      Loading payment form…
    </div>
  );
}

export default StripeSubscribeModal;